// The assistant's pilot metrics (COMY1-390), sent to the Google Analytics tag
// public/index.html already loads. Never the message text, a job number or a
// name: only what happened, the role and counts. Does nothing when the tag is
// blocked or absent.

// the role view the chat is open in (supplier, manager, moderator), set by AgentChat
let agentRole = "supplier";
export function setAgentRole(role) {
  if (role) agentRole = role;
}

export function trackAgent(event, params = {}) {
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", `agent_${event}`, { agent_role: agentRole, ...params });
    }
  } catch (error) {
    // analytics must never break the chat
  }
}
